import { render, staticRenderFns } from "./conFile.vue?vue&type=template&id=28b3c502&scoped=true"
import script from "./conFile.vue?vue&type=script&lang=js"
export * from "./conFile.vue?vue&type=script&lang=js"
import style0 from "./conFile.vue?vue&type=style&index=0&id=28b3c502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3c502",
  null
  
)

export default component.exports